$(function() {
    const $podcastHolderPage = $('.PodcastHolderPage');
    if (!$podcastHolderPage.length) return;

    const generalEmailFormHtml = $('#general-email-form').html(), // get the form html from the form which is in the footer
        $generalEmailFormWrapper = $('.podcast-general-email-form'),
        $generalEmailFormMessages = $('.podcast-general-email-form-messages'),
        $subscribeBtn = $('.podcast-subscribe-btn'),
        $successMessage = $('.podcast-general-email-form-success-message');

    $generalEmailFormWrapper.html(generalEmailFormHtml); // put the form html into our form wrapper div
    $('#general-email-form').remove(); // remove the form from the footer

    // update the form
    const $generalEmailForm = $('#GeneralEmailForm_GeneralEmailForm');
    $generalEmailForm.parsley(); // enable JS error checking
    $('#GeneralEmailForm_GeneralEmailForm_Type').val('podcast');
    $('#GeneralEmailForm_GeneralEmailForm_Message').val('');
    $generalEmailForm.find('button[type="submit"]').text('Subscribe');

    $subscribeBtn.on('click', function(e) {
        e.preventDefault();

        const $this = $(this);

        $this.hide();
        $generalEmailFormWrapper.show();
    });

    $generalEmailForm.on('submit', function(e) {
        e.preventDefault();

        let $this = $(this),
            formAction = $this.attr('action'),
            formData = $this.serialize();

        $generalEmailFormWrapper.hide();
        $generalEmailFormMessages.hide();

        $.post(formAction, formData, function(data) {
            // console.log(data);
            // data.messages - This is either false or an array of strings
            if (data.status == 1) {
                $successMessage.show();
            } else {
                $generalEmailFormWrapper.show();
                // show error messages from data.messages
                if (data.messages) {
                    $generalEmailFormMessages.html(data.messages.join('<br>'));
                    $generalEmailFormMessages.show();
                }
            }
        }, 'json');

    });
});



// WEBPACK FOOTER //
// ./js/modules/podcastHolderPage.js